import store from "../store/index";
import axios from "axios";
// import { ElMessage } from "element-plus";
import router from "../router/index";
import { getUser } from "./localstore";
const instance = axios.create({
  // baseURL: 'https://yxy.medsky.cn/api/'
  // baseURL: 'http://yixinyuan.cc/api/'
  // baseURL: 'http://yxytest.medsky.cn/api/'
  // baseURL: "https://yxy.netloop.cn/api/", //原版
  // baseURL: "https://lib.api.medsky.cn/api/", //最新版
  // baseURL: "http://192.168.1.168:8012/api/", //本地版
  baseURL: "https://vidmed.api.medsky.cn/api/",
});
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    if (getUser() && getUser().token) {
      config.headers.token = getUser()?.token;
    }

    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// // 添加响应拦截器
// instance.interceptors.response.use(
//   function (response) {
//     // 对响应数据做点什么
//     const data = response.data;
//     // console.log("相应拦截数据",response);
//     return data;
//   },
//   function (error) {
//     console.log("被拦截了", error);
//     store.commit("user/removeuser");
//     if (error.response) {
//       switch (error.response.status) {
//         case 401:
//           console.error("未授权，请重新登录");
//           break;
//         case 404:
//           console.error("请求的资源不存在");
//           break;
//         case 500:
//           console.error("服务器内部错误");
//           break;
//         default:
//           console.error("请求失败", error.response.data);
//       }
//     } else {
//       console.error("网络错误，请检查网络连接");
//     }
//     // router.push('/')
//     // 对响应错误做点什么
//     // this.$router.push('/')
//     return Promise.reject(error);
//   }
// );

instance.interceptors.response.use(
  (response) => {
    console.log(response, "response");
    const data = response.data;
    console.log(data, "data");
    return data;
  },
  (error) => {
    console.log(error, "error");
    //  return Promise.reject(error);
    return error;
  }
);
// // 响应拦截器
// instance.interceptors.response.use(
//   (response) => {
//     // 对响应数据做些什么
//     const data = response.data;
//     // console.log("相应拦截数据",response);
//     return data;
//   },
//   (error) => {
//     // 对响应错误做些什么
//     console.log(error, "error");
//     if (error.response) {
//       switch (error.response.status) {
//         case 401:
//           console.error("未授权，请重新登录");
//           break;
//         case 404:
//           console.error("请求的资源不存在");
//           break;
//         case 500:
//           console.error("服务器内部错误");
//           break;
//         default:
//           console.error("请求失败", error.response.data);
//       }
//     } else {
//       console.error("网络错误，请检查网络连接");
//     }
//     return Promise.reject(error);
//   }
// );
// 请求接口
const http = {
  get(url = "", params = "") {
    return new Promise((resolve, reject) => {
      instance({
        url,
        params,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        method: "get",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post(url = "", params = "") {
    return new Promise((resolve, reject) => {
      instance({
        url,
        data: params,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        method: "post",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
export default http;
